angular.module('rjmNg.directives').directive "metricDetails", [
  "$url"
  ($url) ->
    restrict: "E"
    templateUrl: "directive.metricDetails.html"
    replace: true
    bindToController: true
    controllerAs: 'view'
    scope:
      metric: "="
    controller: [
      "logger"
      "notification"
      "Metrics"
      "app"
      "StructureCache"
      "FilterSets"
      "metricEnums"
      "errorConstants"
      "$q"
      "$scope"
      "$location"
      "encodedLetterString"
      (
        logger
        notification
        Metrics
        app
        StructureCache
        FilterSets
        metricEnums
        errorConstants
        $q
        $scope
        $location
        encodedLetterString
      ) ->
        view = @

        view.structure = []
        view.isSupportUser = app.isSupportUserSession()
        view.baseUrl = $url("")
        view.isAdmin = app.isAdminUser()
        view.loading = true
        view.aggregates = metricEnums.AGGREGATE_FUNCTIONS
        view.clientId = app.getClientId()
        view.encodedLetterString = encodedLetterString

        view.filterSets = []
        view.tables = []
        view.columns = []

        view.expansionLoading = {}
        notificationTimeout = 15

        _loadStructure = ->
          $q.all([
            StructureCache.getStructure(),
            FilterSets.get(app.getClientId())
          ]).then(
            (response) ->
              [structure, filterSets] = response
              view.structure = structure
              view.tables = []
              view.columns = []
              view.tables.push table for id, table of structure.tables
              view.columns.push column for id, column of structure.columns
              view.filterSets[filter.id] = filter for filter in filterSets

              view.loading = false
            , (error) ->
              view.loading = false
              notification.error("Server Error",
                errorConstants.SERVER_ERROR_MESSAGE,
                "metrics",
                null,
                notificationTimeout
              )
          )

        _loadFullMetricBasedOnLocation = (metricID) ->
          if $location.path().match(///
            \/reports\/sql  # match the URL which begins with reports/sql
            \/?\d*          # since URLs for reports can have different endings, match those if they exist as well
            ///)
            view.loadFullMetric(metricID)
          else if metricID is view.metric.id
            view.loadFullMetric(view.metric.id)

        view.loadFullMetric = (id) ->
          if $location.path() is "/settings/metric/"
            logger.log('Metrics Page Usage', 'Details', 1, 'list')
          view.expansionLoading[id] = true
          Metrics.get(app.getClientId(), id)
          .then (value, responseHeaders) ->
            angular.extend(view.metric, value)
            view.expansionLoading[id] = false
          .catch (httpResponse) ->
            view.expansionLoading[id] = false
            notification.error("Server Error",
              errorConstants.SERVER_ERROR_MESSAGE,
              "metrics",
              null,
              notificationTimeout
            )

        $scope.$on 'expandMetricDetails', (event, metricID) ->
          _loadFullMetricBasedOnLocation(metricID)

        _loadStructure()

        return view
    ]
]
